import { IonButton, IonButtons, IonHeader, IonIcon, IonSpinner, IonToolbar } from '@ionic/react';
import { useEffect, useState } from 'react';

import { arrowBack } from 'ionicons/icons';
import { AttachmentAssetType, IAttachment } from '../../models/dms/attachment.model';
import { IonModalWrapper } from './MediaModal.styles';
import { getMediaAttachment } from '../../api/dms/mediaAttachment.api';
import { logTransaction } from '../../common/log';
import { LogType } from '../../models/log.model';

export interface IComponentProps {
  showModal: boolean;
  attachment: IAttachment;
  assetType: AttachmentAssetType;
  assetKey: string;
  handleDismiss?: () => void;
}

const MediaModal: React.FC<IComponentProps> = function ({ showModal, attachment, assetType, assetKey, handleDismiss }) {
  const [src, setSrc] = useState<string>();
  const [isLoading, setIsLoading] = useState(false);
  const [isVideoFile, setIsVideoFile] = useState(false);
  const [previousShowModal, setPreviousShowModal] = useState<boolean>(false);

  useEffect(() => {
    const getMedia = async (lineNumber: number) => {
      setIsLoading(true);

      if (showModal && !previousShowModal) {
        if (attachment.demoUrl) {
          // Demo
          setSrc(attachment.demoUrl);
        } else {
          const isVideoRef = attachment.fileName.includes('-video-');
          setIsVideoFile(isVideoRef);

          if (attachment.fileName.startsWith('http')) {
            // Attachment is hosted on a URL
            setSrc(attachment.fileName);
          } else {
            // Attachment is hosted on the server
            if (isVideoRef) {
              // Videos can't be served from the server
              logTransaction(LogType.Warn, "Videos can't be served from the server");
            } else {
              const image = await getMediaAttachment(assetType, assetKey, lineNumber);
              const url = URL.createObjectURL(image);
              setSrc(url);
              setIsLoading(false);
            }
          }
        }
        setIsLoading(false);
      } else if (!showModal && previousShowModal) {
        if (src) {
          URL.revokeObjectURL(src);
        }
        setSrc(undefined);
        setIsVideoFile(false);
        setIsLoading(false);
      }
    };

    getMedia(attachment.lineNumber);

    setPreviousShowModal(showModal); // Update previous showModal state

    return () => {
      if (src) {
        URL.revokeObjectURL(src);
      }
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [attachment.lineNumber, showModal]);

  return (
    <IonModalWrapper
      isOpen={showModal}
      onDidDismiss={() => {
        if (showModal) {
          handleDismiss && handleDismiss();
        }
      }}>
      <IonHeader color="lightest">
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonButton fill="solid" onClick={() => handleDismiss && handleDismiss()}>
              <IonIcon icon={arrowBack} />
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      {src ? (
        <div className="fill">
          {isVideoFile ? <video controls className="video" src={`${src}#t=0.01`} preload="metadata" /> : <div className="img" style={{ backgroundImage: `url('${src}')` }}></div>}
          {isLoading && <IonSpinner name="lines" color="white" className="spinner-position" />}
        </div>
      ) : (
        <div className="fill">{isLoading && <IonSpinner name="lines" color="white" className="spinner-position" />}</div>
      )}
    </IonModalWrapper>
  );
};

export default MediaModal;
